import React, { useMemo } from 'react';
import { Container, Box } from '@mui/material';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Login from './Login';
import SignUp from './SignUp';

const AuthPage = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const redirectTarget = useMemo(() => {
    try {
      const params = new URLSearchParams(location.search);
      const raw = params.get('redirect');
      if (!raw) return null;
      const decoded = decodeURIComponent(raw);
      if (decoded.startsWith('/')) return decoded;
      return null;
    } catch {
      return null;
    }
  }, [location.search]);
  const urlWantsSignup = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('mode') === 'signup';
  }, [location.search]);

  if (user) {
    return <Navigate to={redirectTarget || '/'} replace />;
  }

  const isLogin = !urlWantsSignup;

  const goToLogin = () => {
    navigate('/login', { replace: true });
  };

  const goToSignup = () => {
    navigate('/login?mode=signup', { replace: true });
  };

  const toggleForm = () => {
    if (isLogin) {
      goToSignup();
    } else {
      goToLogin();
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        {isLogin ? (
          <Login onToggleForm={toggleForm} />
        ) : (
          <SignUp onToggleForm={toggleForm} />
        )}
      </Box>
    </Container>
  );
};

export default AuthPage;
